import styled from 'styled-components';

export const Wrapper = styled.div`
  .title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .description {
    color: var(--fontMutedColor);
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
  .date {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 20px;
  }
  .date-items {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
  .date-item {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }
  .finish-item {
    color: var(--errorColor, #ef4444);
    .red-icon {
      filter: invert(36%) sepia(85%) saturate(2000%) hue-rotate(335deg) brightness(95%) contrast(95%);
    }
  }
`
